import { z } from "zod";

export const slotSchema = z.object({
  placeholderId: z.number().optional(),
  residentId: z.number().optional(),
});

export type Slot = z.infer<typeof slotSchema>;
